import { SearchContainer } from '@/features/shop/components/SearchContainer'
import { RouteName } from '@shared/constants/routes'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { withHeaderLayout } from '@/features/shared/components/Headers/Layouts/HeaderLayout'
import { inferZipAndStoreForSlugifiedRoute } from '@/features/shared/serverUtils/inferZipAndStoreForSlugifiedRoute'

export const getServerSideProps = createServerSidePropsHandler(
  RouteName.SEARCH,
  inferZipAndStoreForSlugifiedRoute,
)

export default withHeaderLayout(SearchContainer, {
  showActivityPunchCardButton: true,
})
